import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { 
  RiVipCrown2Fill, 
  RiCheckDoubleLine, 
  RiTimeLine, 
  RiShieldCheckLine, 
  RiFileCopyLine,
  RiArrowRightLine
} from 'react-icons/ri';
import ComboModel from '../../models/ComboModel';
import Swal from 'sweetalert2';

function ModalComboPromo({ show, onHide, onOrderSuccess }) {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    ComboModel.getPlans()
      .then(res => {
        if (res.data) setPlans(res.data);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
  };

  const handleCreateOrder = () => {
    if (!selectedPlan) return;
    setLoading(true);
    ComboModel.createOrder({ combo_type: selectedPlan.type })
      .then(res => {
        setLoading(false);
        if (res.success) {
          setOrderData(res.data);
          if (onOrderSuccess) onOrderSuccess();
        } else {
          Swal.fire({
            icon: 'error',
            title: res.message || 'Tạo yêu cầu thất bại!'
          });
        }
      })
      .catch(err => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: err?.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại sau!'
        });
      });
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      icon: 'success',
      title: 'Đã copy vào bộ nhớ tạm!',
      timer: 1200,
      showConfirmButton: false
    });
  };

  const handleClose = () => {
    setSelectedPlan(null);
    setOrderData(null);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      dialogClassName="modal-combo-promo"
    >
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <RiVipCrown2Fill style={{ color: 'var(--wus-warning-text)' }} size={20} />
          <span>ĐẶC QUYỀN VIP - GÓI COMBO TẠO BANK ẢO TIẾT KIỆM</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '24px' }}>
        {!orderData ? (
          <div>
            {/* Header intro */}
            <div className="text-center mb-3">
              <span style={{ 
                background: 'var(--wus-warning-bg)', 
                color: 'var(--wus-warning-text)', 
                border: '1px solid var(--wus-warning-border)',
                padding: '4px 12px', 
                borderRadius: '999px', 
                fontSize: '11.5px', 
                fontWeight: '600' 
              }}>
                TIẾT KIỆM TỚI 65% CHI PHÍ TẠO VÀ QUẢN LÝ BANK
              </span>
              <h4 className="mt-2 mb-1" style={{ color: 'var(--wus-text)', fontWeight: '700', fontSize: '18px' }}>
                Bảng Giá Các Gói Combo VIP Tạo &amp; Gia Hạn Bank
              </h4>
            </div>

            {/* Lifetime Reservation VIP Banner */}
            <div className="p-3 mb-4 text-start" style={{
              background: 'var(--wus-warning-bg)',
              border: '1px solid var(--wus-warning-border)',
              borderRadius: '10px'
            }}>
              <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                <span className="badge" style={{ background: 'var(--wus-warning)', color: '#ffffff', fontSize: '11px', fontWeight: '700', padding: '4px 8px' }}>
                  👑 ĐẶC QUYỀN VIP VĨNH VIỄN
                </span>
                <span style={{ color: 'var(--wus-warning-text)', fontWeight: '700', fontSize: '14px' }}>
                  BẢO LƯU SỐ LƯỢT TRỌN ĐỜI - SỐ LƯỢT KHÔNG DÙNG VẪN CÒN MÃI MÃI!
                </span>
              </div>
              <div style={{ color: 'var(--wus-text-secondary)', fontSize: '12.5px', lineHeight: '1.6' }}>
                <div>• <strong>Bảo lưu vĩnh viễn không giới hạn thời gian</strong>: Toàn bộ số lượt bạn nạp sẽ được lưu trữ vĩnh viễn trong tài khoản, không bao giờ bị mất hay hết hạn.</div>
                <div>• <strong>Áp dụng cho cả Bank cũ có sẵn &amp; Bank mới</strong>: Bạn có thể dùng lượt combo để <strong>Gia hạn các tài khoản app ĐANG CÓ SẴN</strong> hoặc <strong>Tạo thêm các tài khoản MỚI</strong> tùy thích (1 lượt = 1 tháng/tài khoản).</div>
                <div>• <strong>Miễn phí 100% sửa STK &amp; CK App</strong>: Mọi tài khoản app được tạo mới hoặc gia hạn từ Combo đều được miễn phí sửa STK và chuyển khoản trong suốt thời hạn bank!</div>
              </div>
            </div>

            {/* Grid 4 combo cards */}
            <div className="row g-3 mb-4">
              {plans.map((p, idx) => {
                const isSelected = selectedPlan?.type === p.type;
                const isPopular = p.type === 'COMBO_10';
                const isVip = p.type === 'COMBO_50';

                return (
                  <div key={idx} className="col-lg-3 col-md-6">
                    <div 
                      onClick={() => handleSelectPlan(p)}
                      style={{
                        background: isSelected ? 'var(--wus-card-inner)' : 'var(--wus-card)',
                        border: isSelected 
                          ? '2px solid var(--wus-primary)' 
                          : isPopular 
                            ? '1px solid var(--wus-warning-border)' 
                            : '1px solid var(--wus-border-strong)',
                        borderRadius: '12px',
                        padding: '18px 16px',
                        cursor: 'pointer',
                        transition: 'all 0.16s ease',
                        position: 'relative',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        boxShadow: isSelected ? 'var(--wus-shadow-md)' : 'var(--wus-shadow-xs)'
                      }}
                    >
                      {isPopular && (
                        <div style={{
                          position: 'absolute',
                          top: '-10px',
                          right: '12px',
                          background: 'var(--wus-warning)',
                          color: '#ffffff',
                          fontSize: '10px',
                          fontWeight: '700',
                          padding: '2px 8px',
                          borderRadius: '999px',
                          textTransform: 'uppercase'
                        }}>
                          Phổ biến nhất
                        </div>
                      )}
                      {isVip && (
                        <div style={{
                          position: 'absolute',
                          top: '-10px',
                          right: '12px',
                          background: 'var(--wus-primary)',
                          color: 'var(--wus-primary-fg)',
                          fontSize: '10px',
                          fontWeight: '700',
                          padding: '2px 8px',
                          borderRadius: '999px',
                          textTransform: 'uppercase'
                        }}>
                          Tối ưu nhất
                        </div>
                      )}

                      <div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6 style={{ color: 'var(--wus-text)', fontWeight: '700', margin: 0, fontSize: '15px' }}>
                            {p.name}
                          </h6>
                        </div>

                        <div className="mb-3">
                          <div style={{ color: 'var(--wus-text)', fontSize: '19px', fontWeight: '700', fontFamily: 'var(--wus-mono)' }}>
                            {p.price.toLocaleString('vi-VN')} <span style={{ fontSize: '12.5px', fontWeight: '500', color: 'var(--wus-text-muted)' }}>VNĐ</span>
                          </div>
                          <div style={{ color: 'var(--wus-text-subtle)', fontSize: '11.5px' }}>
                            ~{p.price_per_slot.toLocaleString('vi-VN')} đ / lượt tạo
                          </div>
                        </div>

                        <div className="p-2 mb-3" style={{ background: 'var(--wus-surface-subtle)', border: '1px solid var(--wus-border)', borderRadius: '8px' }}>
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <span style={{ color: 'var(--wus-text-muted)', fontSize: '12px' }}>Số lượt tạo bank:</span>
                            <span style={{ color: 'var(--wus-text)', fontWeight: '700', fontSize: '13px', fontFamily: 'var(--wus-mono)' }}>
                              {p.total_slots} lượt
                            </span>
                          </div>
                          {p.bonus > 0 && (
                            <div className="d-flex align-items-center justify-content-between">
                              <span style={{ color: 'var(--wus-success-text)', fontSize: '12px', fontWeight: '600' }}>Tặng thêm:</span>
                              <span style={{ color: 'var(--wus-success-text)', fontWeight: '700', fontSize: '12px' }}>
                                +{p.bonus} lượt miễn phí
                              </span>
                            </div>
                          )}
                        </div>

                        <div style={{ fontSize: '12px', color: 'var(--wus-text-secondary)' }} className="d-flex flex-column gap-2 mb-3">
                          <div className="d-flex align-items-start gap-2">
                            <RiTimeLine style={{ color: 'var(--wus-warning-text)', flexShrink: 0, marginTop: '2px' }} size={14} />
                            <span style={{ color: 'var(--wus-warning-text)', fontWeight: '600' }}>Bảo lưu VĨNH VIỄN trọn đời</span>
                          </div>
                          <div className="d-flex align-items-start gap-2">
                            <RiCheckDoubleLine style={{ color: 'var(--wus-text)', flexShrink: 0, marginTop: '2px' }} size={14} />
                            <span>Tạo mới &amp; Gia hạn app cũ (1 tháng/lượt)</span>
                          </div>
                          <div className="d-flex align-items-start gap-2">
                            <RiShieldCheckLine style={{ color: 'var(--wus-success-text)', flexShrink: 0, marginTop: '2px' }} size={14} />
                            <span>Free sửa STK &amp; CK trọn hạn bank</span>
                          </div>
                        </div>
                      </div>

                      <button 
                        type="button"
                        className={`btn w-100 ${isSelected ? 'btn-primary' : 'btn-secondary'}`}
                      >
                        {isSelected ? '✓ Đã chọn gói này' : 'Chọn gói này'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Action Bar */}
            <div className="d-flex align-items-center justify-content-between pt-3" style={{ borderTop: '1px solid var(--wus-border)' }}>
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={handleClose}
              >
                Để sau / Đóng
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCreateOrder}
                disabled={!selectedPlan || loading}
              >
                <span>{loading ? 'Đang tạo đơn...' : selectedPlan ? `Xác nhận mua ${selectedPlan.name}` : 'Vui lòng chọn 1 gói combo'}</span>
                <RiArrowRightLine size={16} />
              </button>
            </div>
          </div>
        ) : (
          /* Step 2: Payment QR View */
          <div className="p-2">
            <div className="text-center mb-3">
              <span className="status-pill ok mb-2">
                <span className="status-dot ok"></span>
                <span>ĐÃ TẠO YÊU CẦU MUA COMBO THÀNH CÔNG (MÃ ĐƠN #{orderData.order_id})</span>
              </span>
              <h5 className="mt-2 mb-1" style={{ color: 'var(--wus-text)', fontWeight: '700' }}>
                Quét Mã VietQR Chuyển Khoản
              </h5>
              <p style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>
                Quét mã QR hoặc chuyển khoản đúng số tiền và nội dung bên dưới. Admin sẽ duyệt và kích hoạt lượt trong ít phút.
              </p>
            </div>

            <div className="row align-items-center">
              {/* QR Code */}
              <div className="col-md-5 text-center mb-3 mb-md-0">
                <div style={{
                  width: '210px',
                  height: '210px',
                  padding: '8px',
                  backgroundColor: '#ffffff',
                  border: '1px solid var(--wus-border-strong)',
                  borderRadius: '12px',
                  margin: '0 auto',
                  boxShadow: 'var(--wus-shadow-sm)'
                }}>
                  <img 
                    src={orderData.qr_url || `https://img.vietqr.io/image/VIB-086714172-compact2.jpg?amount=${orderData.price}&addInfo=${encodeURIComponent(orderData.transfer_content || '')}&accountName=NGUYEN+THI+HOA`} 
                    alt="VietQR Code" 
                    width="194" 
                    height="194" 
                    style={{ borderRadius: '6px', objectFit: 'contain' }}
                    onError={(e) => {
                      e.target.src = `https://img.vietqr.io/image/VIB-086714172-compact2.jpg?amount=${orderData.price}&addInfo=${encodeURIComponent(orderData.transfer_content || '')}&accountName=NGUYEN+THI+HOA`;
                    }}
                  />
                </div>
                <div className="mt-2" style={{ color: 'var(--wus-text-subtle)', fontSize: '12px' }}>
                  Quét bằng App Ngân Hàng bất kỳ
                </div>
              </div>

              {/* Bank Details */}
              <div className="col-md-7">
                <div className="wus-info-box">
                  <div className="mb-2 pb-2 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Gói Combo:</span>
                    <span style={{ color: 'var(--wus-text)', fontWeight: '700', fontSize: '14px' }}>
                      {orderData.combo_name} ({orderData.slots} lượt)
                    </span>
                  </div>

                  <div className="mb-2 pb-2 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Số tiền thanh toán:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: 'var(--wus-text)', fontWeight: '700', fontSize: '15px', fontFamily: 'var(--wus-mono)' }}>
                        {orderData.price.toLocaleString('vi-VN')} VNĐ
                      </span>
                      <button 
                        className="btn btn-secondary btn-sm" 
                        onClick={() => copyToClipboard(orderData.price.toString())}
                      >
                        <RiFileCopyLine size={13} />
                      </button>
                    </div>
                  </div>

                  <div className="mb-2 pb-2 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Ngân hàng thụ hưởng:</span>
                    <span style={{ color: 'var(--wus-text)', fontWeight: '600', fontSize: '13px' }}>
                      {orderData.bank_name}
                    </span>
                  </div>

                  <div className="mb-2 pb-2 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Số tài khoản:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: 'var(--wus-text)', fontWeight: '700', fontSize: '14px', fontFamily: 'var(--wus-mono)' }}>
                        {orderData.bank_account_no}
                      </span>
                      <button 
                        className="btn btn-secondary btn-sm" 
                        onClick={() => copyToClipboard(orderData.bank_account_no)}
                      >
                        <RiFileCopyLine size={13} />
                      </button>
                    </div>
                  </div>

                  <div className="mb-2 pb-2 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Chủ tài khoản:</span>
                    <span style={{ color: 'var(--wus-text)', fontWeight: '600', fontSize: '13px' }}>
                      {orderData.bank_account_name}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: 'var(--wus-warning-text)', fontSize: '13px', fontWeight: '600' }}>Nội dung chuyển khoản:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: 'var(--wus-warning-text)', fontWeight: '700', fontSize: '14px', fontFamily: 'var(--wus-mono)' }}>
                        {orderData.transfer_content}
                      </span>
                      <button 
                        className="btn btn-secondary btn-sm" 
                        onClick={() => copyToClipboard(orderData.transfer_content)}
                      >
                        <RiFileCopyLine size={13} />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="mt-3 text-end">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleClose}
                  >
                    Đã chuyển khoản xong (Đóng)
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ModalComboPromo;
